export const screenSizes = {
  micro: 1, // small mobile
  smallest: 2, // mobile
  // smaller: 3,
  medium: 5, // tablet
  normal: 7, // desktop
};

export const verticalScreenSizes = {
  small: 3,
  medium: 4,
  large: 5,
  largest: 7,
};

/**
  0 - 600: (unused)
  0 - 1279: mobile
  1280 - 1350: tablet (used rarely)
  1280 and more: desktop
 */
export const detectResolution = () => {
  const { clientWidth, clientHeight } = window.document.documentElement;
  // console.log({ clientHeight });
  const resolution =
    clientWidth <= 600
      ? screenSizes.micro
      : clientWidth <= 1279
      ? screenSizes.smallest
      : clientWidth <= 1350
      ? screenSizes.medium
      : screenSizes.normal;

  const verticalResolution =
    clientHeight <= 825
      ? verticalScreenSizes.small
      : clientHeight <= 930
      ? verticalScreenSizes.medium
      : clientHeight <= 1150
      ? verticalScreenSizes.large
      : verticalScreenSizes.largest;
  return {
    resolutionIndex: resolution,
    isMobile: resolution <= screenSizes.smallest,
    isTablet: resolution === screenSizes.medium,
    verticalResolutionIndex: verticalResolution,
  };
};
